export default __webpack_public_path__ + "media/plus/plus-bigger-ac9827a9.png";